import { render, staticRenderFns } from "./ElsaTableLayout.vue?vue&type=template&id=c8e64634&scoped=true&"
import script from "./ElsaTableLayout.vue?vue&type=script&lang=js&"
export * from "./ElsaTableLayout.vue?vue&type=script&lang=js&"
import style0 from "./ElsaTableLayout.vue?vue&type=style&index=0&id=c8e64634&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e64634",
  null
  
)

export default component.exports